import { Component, OnInit, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import "jquery-slimscroll";
import { MessageService } from "primeng/components/common/messageservice";
import { PageService, AuthService, NotificationCenterService } from "../../../services/index";
import { Page, User, NotificationCenter } from "../../../models/index";
import { environment } from "../../../../environments/environment";
import { PermissionService } from "../../../services/permission.service";
import { SeriNumberViewModel } from "../../../view-model/SeriNumber.viewModel";
import { SignalRService } from "../../../services/signalR.service";
import { HubConnection } from "@aspnet/signalr";
import { Constant } from "../../../infrastructure/constant";
import { PersistenceService, StorageType } from 'angular-persistence';
declare var jQuery: any;

@Component({
  selector: "app-navigation",
  templateUrl: "navigation.component.html",
  styles: []
})
export class NavigationComponent implements OnInit {

  constructor(
    protected messageService: MessageService,
    private pageService: PageService,
    protected signalRService: SignalRService,
    private notificationCenterService: NotificationCenterService,
    private el: ElementRef,
    public permissionService: PermissionService,
    public router: Router,
    protected authService: AuthService,
    private persistenceService: PersistenceService
  ) {
  }
  styleBackGround: string;
  isToggle: boolean = false;
  saveSelectedIndex: number;
  hubConnection: HubConnection;
  selectNavItemIndex: number = null;
  notificationCenter: NotificationCenter = new NotificationCenter();
  //
  logo: string = environment.urlLogo;
  logoMini: string = environment.urlLogoMini;
  pages: Page[];
  sideMenu: any;
  ngOnInit() {
    //
    if (environment.namePrint === "Vintrans") {
      this.styleBackGround = "#fff";
    } else {
      this.styleBackGround = "#000000";
    }
    this.sideMenu = jQuery(this.el.nativeElement).find("#side-menu");
    this.pageService.getMenuByModuleId(3).subscribe(x => {
      if (x.isSuccess == false) return;
      this.pages = x.data as Page[];

      this.pages.forEach(element => {
        element.children = this.pages.filter(
          x => x.parentPageId === element.id
        );
      });
      this.sideMenu.metisMenu("dispose");
      if (jQuery("body").hasClass("fixed-sidebar")) {
        jQuery(".sidebar-collapse").slimscroll({
          height: "100%"
        });
      }
      this.pages.forEach(element => {
        element.display = "none";
        element.active = "noactive";
      });
      //check time login
      let datetimeLogin = this.persistenceService.get(Constant.auths.datetimeLogin, StorageType.LOCAL);
      if (datetimeLogin) {
        var timeLogin = new Date(datetimeLogin);
        var timeCurrent = new Date();
        if (timeCurrent.getDay() != timeLogin.getDay()) {
          this.logOut();
        }
      } else {
        this.logOut();
      }
      //
      this.getNotificationMenu();
      this.hubConnect();
    });
  }

  public logOut() {
    this.authService.logout();
  }

  async hubConnect() {
  }

  ngOnDestroy() {
  }

  ngAfterViewInit() {
    jQuery("#side-menu").metisMenu();

    if (jQuery("body").hasClass("fixed-sidebar")) {
      jQuery(".sidebar-collapse").slimscroll({
        height: "100%"
      });
    }
  }

  selectNav(select) {
    if (
      !select.parentPageId &&
      (select.children && select.children.length === 0)
    ) {
      this.pages.forEach(x => {
        if (x != select) {
          let index = this.pages.indexOf(x);
          this.pages[index].display = "none";
          this.pages[index].active = "noactive";
        }
      });
      this.isToggle = false;
    }
    if (
      !select.parentPageId &&
      (select.children && select.children.length > 0)
    ) {
      let index = this.pages.indexOf(select);
      this.saveSelected();
      this.selectNavItemIndex = index;
    }
  }

  saveSelected() {
    this.saveSelectedIndex = this.selectNavItemIndex;
  }

  showItems(event, page) {
    setTimeout(() => {
      if (
        this.saveSelectedIndex == null ||
        this.saveSelectedIndex !== this.selectNavItemIndex
      ) {
        this.isToggle = true;
        this.pages[this.selectNavItemIndex].display = "block";
        this.pages[this.selectNavItemIndex].active = "active";
        if (this.saveSelectedIndex) {
          this.pages[this.saveSelectedIndex].display = "none";
          this.pages[this.saveSelectedIndex].active = "noactive";
        }
      } else {
        this.pages[this.selectNavItemIndex].display = "none";
        this.pages[this.selectNavItemIndex].active = "noactive";
        if (this.saveSelectedIndex) {
          this.pages[this.saveSelectedIndex].display = "none";
          this.pages[this.saveSelectedIndex].active = "noactive";
        }
        //
        this.isToggleItem();
      }
    }, 0);
  }

  isToggleItem() {
    if (this.isToggle == false) {
      this.pages[this.selectNavItemIndex].display = "block";
      this.pages[this.selectNavItemIndex].active = "active";
      this.isToggle = true;
    } else {
      this.pages[this.selectNavItemIndex].display = "none";
      this.pages[this.selectNavItemIndex].active = "noactive";
      this.isToggle = false;
    }
  }

  chooseItems(event, page){
    if(window.innerWidth <900){
      this.pages[this.selectNavItemIndex].display = "none";
      this.pages[this.selectNavItemIndex].active = "noactive";
      this.isToggle = false;
    }
  }
  async getNotificationMenu() {
    var res = await this.notificationCenterService.getNotificationMenuAsync();
    if (res) {
      this.notificationCenter = res;
      //awaitAccountingAcceptListReceiptMoney
      let awaitAccountingAcceptListReceiptMoney = this.pages.find(f => f.parentPageId && f.aliasPath.indexOf(Constant.pages.receiptMoney.children.comfirmMoneyFromHub.alias) > 0);
      if (awaitAccountingAcceptListReceiptMoney) awaitAccountingAcceptListReceiptMoney.notification = this.notificationCenter.countPrioritize + this.notificationCenter.countListReceiptMoneyAccept;
      //inventory
      let inventory = this.pages.find(f => f.parentPageId && f.aliasPath.indexOf(Constant.pages.warehouse.children.inventory.alias) > 0);
      if (inventory) inventory.notification = this.notificationCenter.countInventory;
      //receiveMoneyFromRider
      let receiveMoneyFromRider = this.pages.find(f => f.parentPageId && f.aliasPath.indexOf(Constant.pages.receiptMoney.children.receiveMoneyFromRider.alias) > 0);
      if (receiveMoneyFromRider) receiveMoneyFromRider.notification = this.notificationCenter.countListReceiptMoneyNew;
      //
      
      this.pages.filter(f => !f.parentPageId).map(
        m => {
          //m.notification = 0;
          let listChild = this.pages.filter(f => f.parentPageId == m.id && f.notification).map(m => m.notification);
          if (listChild && listChild.length > 0) m.notification = listChild.reduce((s, c) => s + c);
        }
      );
    }
  }
}
